import { useRouter } from 'vue-router';
export function useOnboardingRouter() {
    var router = useRouter();
    var backwards = function () { return router.go(-1); };
    var create = function () { return router.push({
        name: 'onboarding.create.show',
        params: {},
    }); };
    var confirm = function (id) { return router.push({
        name: 'onboarding.confirm.show',
        params: { id: id },
    }); };
    var profile = function (id) { return router.push({
        name: 'onboarding.profile.show',
        params: { id: id },
    }); };
    var complete = function (id) { return router.push({
        name: 'onboarding.complete.show',
        params: { id: id },
    }); };
    var dashboard = function () { return router.push({
        name: 'dashboard',
        params: {},
    }); };
    return {
        create: create,
        confirm: confirm,
        complete: complete,
        dashboard: dashboard,
        profile: profile,
        backwards: backwards,
    };
}
;
